import useSWR, { mutate } from 'swr';
import type { MatterMember } from '@/types/base';
import {backendClient} from '@/lib/api-client';

// Custom fetcher that uses our apiClient with authentication
const fetcher = async (url: string) => {
  const response = await backendClient.get(url);
  return response.data;
};

const useMatterMembers = (guid: string | undefined) => {
  // Only construct URL if guid is valid (not undefined, null, or empty string)
  const url = guid && guid !== 'undefined' ? `/matter/${guid}/members` : null;

  const { data, error, isLoading } = useSWR<MatterMember[]>(
    url,
    fetcher
  );

  const mutateMatterMembers = async () => {
    if (url) {
      mutate(url);
    }
  };

  // Make sure we return a consistent data structure even if the API hasn't returned yet
  return {
    isLoading,
    isError: error,
    members: data || [],
    mutateMatterMembers,
  };
};

export default useMatterMembers; 
